import { render, staticRenderFns } from "./NotFoundPropertys.vue?vue&type=template&id=062b8d0a&lang=true"
import script from "./NotFoundPropertys.vue?vue&type=script&lang=js"
export * from "./NotFoundPropertys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports